import { render, staticRenderFns } from "./RegisterBuyer.vue?vue&type=template&id=317fb308&scoped=true"
import script from "./RegisterBuyer.vue?vue&type=script&lang=js"
export * from "./RegisterBuyer.vue?vue&type=script&lang=js"
import style0 from "./RegisterBuyer.vue?vue&type=style&index=0&id=317fb308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317fb308",
  null
  
)

export default component.exports